export enum Role {
    Admin = 1,
    User = 2,
    Visitor = 3
}
